import React from 'react'
import {Link} from 'gatsby'
import buttonsStyle from "../components/css/buttonsStyle.module.scss"
import learnMoreBoxStyle from "../components/css/learnMoreBoxStyle.module.scss";

export default function({children, cta, to, ctaIntro, coverImage}){
    
    return (
        <div>
        {coverImage &&
            <div className={learnMoreBoxStyle.cover} style={{backgroundImage: "url(/assets/"+coverImage+")"}}></div>
        }
        <article className={learnMoreBoxStyle.article}>
            {children}
        {
            ctaIntro && 
            <div className={learnMoreBoxStyle.ctaIntro}>{ctaIntro}</div>
        }
         <Link className={buttonsStyle.btn + " "+buttonsStyle.primary} to={to}>{cta}</Link>
        </article>  
        </div>      
    )
}